export function modalnotificaciones(titulo, body, tamano, cerrar, modal) {
    modal   = modal || "#modalnotificaciones";
    titulo  = titulo || "Aviso";
    body    = body || "¡Alerta!";
    tamano  = tamano || "";
    //cerrar  = cerrar || true;
    let backdrop    = true,
        keyboard    = true;

    if (cerrar !== false) {
        backdrop = true;
        keyboard = true;

    } else {
        backdrop = 'static';
        keyboard = false;
    }

    $(modal).find("h5").text(titulo);
    //$(modal).removeClass(tamano);
    $(modal).find(".modal-body").html(body);
    $(modal).find(".modal-dialog").removeClass("modal-lg");
    $(modal).find(".modal-dialog").addClass(tamano);

    $(modal).modal({
            backdrop: backdrop,
            keyboard: keyboard
        }
    );

    $('[data-toggle=\"tooltip\"]').tooltip('show');
}
export function modaldata(titulo, tamano, cerrar, modal) {
    modal   = modal || "#modalnotificaciones";
    titulo  = titulo || "Aviso";
    tamano  = tamano || "";
    //cerrar  = cerrar || true;
    let backdrop    = true,
        keyboard    = true;

    if (cerrar !== false) {
        backdrop = true;
        keyboard = true;

    } else {
        backdrop = 'static';
        keyboard = false;
    }

    $(modal).find("h5").text(titulo);
    //$(modal).removeClass(tamano);
    $(modal).find(".modal-dialog").removeClass("modal-lg");
    $(modal).find(".modal-dialog").addClass(tamano);

    $(modal).modal({
            backdrop: backdrop,
            keyboard: keyboard
        }
    );

    $('[data-toggle=\"tooltip\"]').tooltip('show');
}

export function slickcarousel() {
    $('.slick').slick({
        dots: false,
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        prevArrow: '<div class="p-2 position-absolute font-16 texto-blanco slick-left index-1 cursor-pointer"><i class="icon-arrow-left"></i></div>',
        nextArrow: '<div class="p-2 position-absolute font-16 texto-blanco slick-right index-1 cursor-pointer"><i class="icon-arrow-right"></i></div>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
}
